import React, { FC, useEffect } from "react";
import { Radio, RadioChangeEvent } from "antd";
import FulfillmentType from "@/enum/FulfillmentType";
import ShopDTO from "@/dto/shop/ShopDTO";
import { delay } from "lodash";
import HistoryOrderHint from "../HistoryOrderHint";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { observer } from "mobx-react-lite";

interface FulfillmentTypeSelectProps {
    shop: ShopDTO;

    tab: OrderTab;
}

const fulfillmentTypeTags = [
    {
        label: "全部订单",
        value: FulfillmentType.ALL,
    },
    {
        label: "自有订单",
        value: FulfillmentType.SELF_SHIPPING,
    },
    {
        label: "代发订单",
        value: FulfillmentType.DROP_SHIPPING,
    },
];

const FulfillmentTypeSelect: FC<FulfillmentTypeSelectProps> = function (props) {
    const { shop, tab } = props;
    const orderManagementStore = useOrderManagementStore();

    const fulfillmentType = orderManagementStore?.table?.listOptions?.fulfillmentType || "";
    const hideDropShipping = [OrderTab.LOGISTICS_WARNING, OrderTab.PICKUP_DEADLINE_WARNING].includes(tab);
    const options = hideDropShipping
        ? fulfillmentTypeTags.filter(({ value }) => value !== FulfillmentType.DROP_SHIPPING)
        : fulfillmentTypeTags;

    useEffect(() => {
        if (!hideDropShipping || fulfillmentType !== FulfillmentType.DROP_SHIPPING) return;

        orderManagementStore.table.changeFulfillmentType(FulfillmentType.ALL);
        orderManagementStore.table.changePageNo(1);
        orderManagementStore.fetchOrders(shop.id, tab);
    }, [hideDropShipping, fulfillmentType, shop.id, tab]);

    // 当选中标签的时候切换
    const onChange = (e: RadioChangeEvent) => {
        const fulfillmentType = e.target.value;

        orderManagementStore.table.resetFormValues();

        delay(() => {
            orderManagementStore.table.changePageNo(1);
            orderManagementStore.table.changeFulfillmentType(fulfillmentType);

            orderManagementStore.fetchOrders(shop.id, tab);
        }, 17);
    };

    return (
        <div className="ec-order-management-fulfillment-type-selector mb10">
            <Radio.Group
                options={options}
                optionType="button"
                buttonStyle="solid"
                value={fulfillmentType}
                onChange={onChange}
            />

            <HistoryOrderHint shop={shop} tab={tab} className="ml10" />
        </div>
    );
};

export default observer(FulfillmentTypeSelect);
